import React from 'react';
import { Container, Button } from 'react-bootstrap';
import './Hero.css';
import heroImage from '../assets/hero-image.jpg'; // Import your hero image

const Hero = () => {
  const scrollToContact = () => {
    document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="hero-section"
      style={{ backgroundImage: `url(${heroImage})` }} // Set the background image
    >
      <Container className="text-center hero-content">
        <h1 className="hero-title">Witamy w naszym hotelu w Czyżewie!</h1>
        <p className="hero-subtitle">
          Komfortowy wypoczynek w przyjemnej atmosferze dla turystów i podróżujących w celach biznesowych.
        </p>
        <Button variant="light" className="hero-btn" onClick={scrollToContact}>
          Skontaktuj się z nami
        </Button>
      </Container>
    </section>
  );
};

export default Hero;
